// extracted by mini-css-extract-plugin
module.exports =  {"image":"AE7qsL"};